<!-- @format -->

@if (!validatablePlan) {
  <sis-contextual-notification variant="warning" [content]="'ENROLMENTS.NO_PLANS_WARNING_TEXT' | translate">
    <sis-button [link]="true" (clicked)="navigateToPlanStructure()" [label]="'ENROLMENTS.NO_PLANS_WARNING_LINK' | translate"></sis-button>
  </sis-contextual-notification>
}

@if (validatablePlanLoaded$ | async) {
  @for (item of visibleCourseUnitsWithPeriods ?? undefined | keyvalue; track item) {
    @if (item.key !== "undefined") {
      <h4
        >{{ "ENROLMENTS.PERIOD" | translate }} {{ this.getStudyPeriodNameByPeriodId(item.key) | localizedString }} /
        {{ this.getStudyYearNameByPeriodId(item.key) }}</h4
      >
    }
    <div class="grid-container">
      @for (courseUnit of item.value; track courseUnit) {
        <div class="grid-item">
          <ng-container [ngTemplateOutlet]="studyBoxTemplate" [ngTemplateOutletContext]="{ courseUnit: courseUnit }" />
        </div>
      }
    </div>
  }
  @if (totalPeriodCount > defaultPeriodCount) {
    <div class="show-more">
      @if (visiblePeriodCount > defaultPeriodCount) {
        <sis-show-more
          (click)="setVisiblePeriodCourseUnits(false)"
          placement="top"
          text="{{ 'ENROLMENTS.SHOW_LESS_PERIODS' | translate }}"></sis-show-more>
      }
      @if (totalPeriodCount > visiblePeriodCount) {
        <sis-show-more
          (click)="setVisiblePeriodCourseUnits(true)"
          placement="bottom"
          text="{{ 'ENROLMENTS.SHOW_MORE_PERIODS' | translate: { count: totalPeriodCount - visiblePeriodCount } }}"></sis-show-more>
      }
    </div>
  }
  @if (visibleUntimedCourseUnits.length > 0) {
    <h4>{{ "ENROLMENTS.NO_PERIOD" | translate }}</h4>
    <div class="grid-container">
      @for (courseUnit of visibleUntimedCourseUnits; track courseUnit) {
        <div class="grid-item">
          <ng-container [ngTemplateOutlet]="studyBoxTemplate" [ngTemplateOutletContext]="{ courseUnit: courseUnit }" />
        </div>
      }
    </div>
    @if (untimedCourseUnits.length > defaultCourseUnitCount) {
      <div class="show-more">
        @if (visibleUntimedCourseUnits.length > defaultCourseUnitCount) {
          <sis-show-more
            (click)="setVisibleUntimedCourseUnits(false)"
            placement="top"
            text="{{ 'ENROLMENTS.SHOW_LESS_COURSE_UNITS' | translate }}"></sis-show-more>
        }
        @if (untimedCourseUnits.length > visibleUntimedCourseUnits.length) {
          <sis-show-more
            (click)="setVisibleUntimedCourseUnits(true)"
            placement="bottom"
            text="{{
              'ENROLMENTS.SHOW_MORE_COURSE_UNITS' | translate: { count: untimedCourseUnits.length - visibleUntimedCourseUnits.length }
            }}"></sis-show-more>
        }
      </div>
    }
  }
  @if (validatablePlan.getAllCourseUnitsInPlan().length === 0) {
    <sis-contextual-notification variant="warning" [content]="'ENROLMENTS.NO_COURSE_UNITS_IN_PLAN_WARNING_TEXT' | translate">
      <sis-button
        [link]="true"
        (clicked)="navigateToPlanStructure()"
        [label]="'ENROLMENTS.NO_COURSE_UNITS_IN_PLAN_LINK' | translate"></sis-button>
    </sis-contextual-notification>
  }
  @if (visibleUntimedCourseUnits.length === 0 && !visiblePeriodCount && validatablePlan.getAllCourseUnitsInPlan().length > 0) {
    <sis-contextual-notification variant="light" [content]="'ENROLMENTS.NO_UNTIMED_COURSE_UNITS_IN_PLAN_TEXT' | translate">
      <sis-button
        [link]="true"
        (clicked)="navigateToPlanStructure()"
        [label]="'ENROLMENTS.NO_UNTIMED_COURSE_UNITS_IN_PLAN_LINK' | translate"></sis-button>
    </sis-contextual-notification>
  }
}

<ng-template #studyBoxTemplate let-courseUnit="courseUnit">
  <sis-study-box
    [id]="courseUnit.id"
    [level]="5"
    [name]="courseUnit.name"
    [code]="courseUnit.code"
    [credits]="courseUnit.credits"
    (nameClickAction)="showCourseUnitModal($event)">
    @if (
      hasSelectableAssessmentItems(courseUnit) && !hasAllAssessmentItemsSelected(courseUnit) && hasCompletionMethodSelected(courseUnit)
    ) {
      <sis-study-notification-box
        study-box="notifications"
        [primaryButtonText]="'ENROLMENTS.SELECT_REALISATIONS' | translate"
        (primaryClickAction)="showSelectCourseUnitRealisationModal(courseUnit)">
      </sis-study-notification-box>
    }
    @if (hasCompletionMethodSelected(courseUnit) && hasAllAssessmentItemsSelected(courseUnit)) {
      <sis-study-notification-box
        study-box="notifications"
        [primaryButtonText]="'ENROLMENTS.CHANGE_REALISATIONS' | translate"
        (primaryClickAction)="showSelectCourseUnitRealisationModal(courseUnit)">
        {{ "ENROLMENTS.ALL_REALISATIONS_SELECTED" | translate }}
      </sis-study-notification-box>
    }
    @if (hasCompletionMethodSelected(courseUnit) && !hasSelectableAssessmentItems(courseUnit)) {
      <sis-study-notification-box study-box="notifications">
        {{ "ENROLMENTS.NO_REALISATIONS_AVAILABLE" | translate }}
      </sis-study-notification-box>
    }
    @if (!hasCompletionMethodSelected(courseUnit)) {
      <sis-study-notification-box study-box="notifications">
        {{ "ENROLMENTS.NO_COMPLETION_METHOD_SELECTED" | translate }}
      </sis-study-notification-box>
    }
  </sis-study-box>
</ng-template>
